export const SSO_PAYLOAD_PARAM = "sso_payload";

/**
 * Decode a base64url-encoded SSO payload from the URL.
 * The first project encodes the login data as base64 and passes it as a query param.
 */
export function decodeSSOPayload(payload) {
  try {
    const decoded = atob(payload);
    return JSON.parse(decoded);
  } catch (error) {
    console.error("Failed to decode SSO payload", error);
    throw error;
  }
}
